var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 16,
  fill: "none",
  "aria-hidden": "true"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008EDE",
  d: "m13.097 0-1.41 1.41L17.267 7H.682v2h16.585l-5.58 5.59 1.41 1.41 8-8-8-8Z"
})));
export default SvgArrow;